// Global States for faster scheduling
import { useStore } from "../../contexts/store";
import RenderMatch from "../../helpers/scheduleHelpers/renderMatch";
import RenderMatchChecked from "../../helpers/scheduleHelpers/renderMatchChecked";
import RenderTimeslot from "../../helpers/scheduleHelpers/renderTimeslot";
import moment from 'moment';
import React from 'react';
import { uuid } from 'uuidv4';
import "./style.css";
export const Schedule = ({
  onDeleteTimeslot,
  growlStore,
  connectedExperts
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    firstMatch,
    submitFirstMatch,
    schedule,
    selectedDate,
    availabilityStore_imp
  } = state;

  const addNewSlot = () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        selectedDate: moment(selectedDate).toDate().getTime(),
        currentPath: 'calendarview',
        readOnly: true,
        updated: true
      }
    });
  };

  const {
    schedule: storeSchedule
  } = availabilityStore_imp;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "overview-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview-content-timeslot-wrapper"
  }, /*#__PURE__*/React.createElement(Header, {
    timeslots: schedule.timeslots,
    firstMatch: firstMatch,
    submitFirstMatch: submitFirstMatch
  }), !storeSchedule && firstMatch === 0 && /*#__PURE__*/React.createElement("div", {
    className: "newSlotContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "addNewSlot",
    onClick: () => addNewSlot()
  }, /*#__PURE__*/React.createElement("h3", null, "Create Timeslot"))), !storeSchedule && firstMatch > 0 && /*#__PURE__*/React.createElement("div", {
    key: uuid(),
    className: "timeslot relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeslot-content",
    id: "timeslot-content"
  }, /*#__PURE__*/React.createElement("div", {
    id: "renderSlice"
  }, submitFirstMatch && /*#__PURE__*/React.createElement(RenderMatchChecked, null), !submitFirstMatch && /*#__PURE__*/React.createElement(RenderMatch, {
    growlStore: growlStore
  })))), !!storeSchedule && /*#__PURE__*/React.createElement(RenderTimeslot, {
    connectedExperts: connectedExperts,
    growlStore: growlStore,
    onDeleteTimeslot: onDeleteTimeslot
  }))));
};

function Header({
  timeslots,
  firstMatch,
  submitFirstMatch
}) {
  if (timeslots.length === 0 && firstMatch > 0 && !submitFirstMatch) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", null, "Suggested Timeslot"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Accept suggested schedule or edit your scheduled timeslot")));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", null, "Scheduled Timeslot"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Delete or modify your scheduled timeslot")));
}